import { getPermissionInfo, login, logout } from '@/api/auth';
import { clearCasePreview, removeToken, setToken } from '@/utils/auth';

// 令牌的唯一来源是 utils/auth.js（响应式 + localStorage），这里只存用户信息
const state = {
  user: null
};

const mutations = {
  SET_USER(context, user) {
    context.user = user || null;
  }
};

const actions = {
  // 用户登录
  async userLogin({ commit }, { username, password }) {
    const data = await login({ username, password });
    setToken(data);
    commit('SET_USER', null);
    return data;
  },
  // 用户登出：接口失败也要把本地状态清干净
  async userLogout({ commit }) {
    try {
      await logout();
    } catch (e) {
      // 令牌可能已失效，忽略即可
    }
    removeToken();
    clearCasePreview();
    commit('SET_USER', null);
  },
  // 获取登录用户信息
  async getUserInfo({ commit }) {
    const data = await getPermissionInfo();
    commit('SET_USER', data && data.user);
    return data;
  }
};

export default {
  state,
  mutations,
  actions
};
